import { createActivityView } from '@/scripts/ui/activityView'
import { isIOS } from '@/scripts/helpers/features'
import analytics, { ACTION_ACTIVITY_OPEN } from '@/scripts/analytics'
import { openActivityModal } from '@/scripts/ui/activityModal'
import { createActivityViewAnalytics } from '@/scripts/ui/activityViewConfig'
import State, { getActivityForDay } from './state'
import MicroModal from 'micromodal'
import type { Activity } from '@/scripts/data/types'
import type { ActivityView } from '@/scripts/ui/activityView'
import { isArchive } from '@/scripts/config/settings'

let activityView: ActivityView | null = null

function initView() {
  // In archive mode, activities are not available
  if (isArchive) {
    return
  }

  const contentEl = State.refs.activityModalContent
  const buttonEl = State.refs.activityButton

  if (!contentEl || !buttonEl) {
    console.warn('Activity elements not found, skipping activity view initialization')
    return
  }

  activityView = createActivityView(contentEl, {
    isMobileOrTablet: true,
    isIOS,
    analytics: createActivityViewAnalytics(),
    openActivity: (act) => openActivityModal(act),
  })

  buttonEl.addEventListener('click', () => openActivityDetailForCurrentDay())
}

function openActivityDetailForCurrentDay() {
  const activity = getActivityForDay(State.day)
  if (!activity || !activityView) return
  openActivityDetail(activity)
}

function openActivityDetail(activity: Activity) {
  if (!activityView) return

  activityView.setActivity(activity)

  if (activity.linkHash) {
    analytics.sendCustomEvent(ACTION_ACTIVITY_OPEN, activity.linkHash)
  }

  try {
    MicroModal.show('modal-activity-detail')
  } catch (err) {
    console.warn('Failed to open detail modal:', err)
  }
}

function setButtonContent(day: number) {
  // In archive mode, activity button doesn't exist
  if (isArchive || !State.refs.activityButton) {
    return
  }
  const btn = State.refs.activityButton
  btn.textContent = String(day)
}

export default { initView, setButtonContent, openActivityDetail }
